import script from "./OrganicRankingOnOrganicImpressions.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganicRankingOnOrganicImpressions.vue?vue&type=script&setup=true&lang=js"

import "./OrganicRankingOnOrganicImpressions.vue?vue&type=style&index=0&id=579b4942&lang=css"

const __exports__ = script;

export default __exports__